import { action } from 'satcheljs';
export default action('SHOW_QUICK_OPTIONS', function () { return ({}); });
//# sourceMappingURL=showQuickOptions.js.map